import { render, staticRenderFns } from "./Camt.vue?vue&type=template&id=70954798&"
import script from "./Camt.vue?vue&type=script&lang=js&"
export * from "./Camt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports